document.addEventListener("DOMContentLoaded", () => {

  const wrapper = document.getElementById("sjDiscountWrapper");
  if (!wrapper) return;

  const tiers = [
    { min: 5, max: 9, discount: 5 },
    { min: 10, max: 49, discount: 7 },
    { min: 50, max: 99, discount: 10 },
    { min: 100, max: 999999, discount: 12 }
  ];

  const els = {
    basePrice: document.getElementById("sjBasePrice"),
    yourPrice: document.getElementById("sjPrice"),
    total: document.getElementById("sjTotal"),
    savings: document.getElementById("sjSaving"),
    discount: document.getElementById("sjCurrentDiscount"),
    reward: document.getElementById("sjNextReward"),
    progress: document.getElementById("sjProgress")
  };

  function money(value) {
    return new Intl.NumberFormat("en-IN", {
      style: "currency",
      currency: "INR",
      minimumFractionDigits: 2
    }).format(value);
  }

  function getBasePrice() {
    return Number(wrapper.dataset.price) || 0;
  }

  function getQty() {
    const input =
      document.querySelector('input[name="quantity"]') ||
      document.querySelector(".quantity__input");

    return input ? parseInt(input.value) || 1 : 1;
  }

  function currentTier(qty) {
    return tiers.find(t => qty >= t.min && qty <= t.max);
  }

  function refreshTable(basePrice, activeTier) {

    document.querySelectorAll(".sj-tier").forEach(row => {

      const discount = Number(row.dataset.discount);

      const price = basePrice * (1 - discount / 100);

      row.querySelector(".sj-tier-price").textContent = money(price);

      row.classList.remove("active");

      if (activeTier && activeTier.discount === discount) {

        row.classList.add("active");

      }

    });

  }

  function refreshReward(qty, activeTier) {

    const next = tiers.find(t => qty < t.min);

    if (!next) {

      els.reward.innerHTML =
        "🎉 You've unlocked our maximum discount.";

      els.progress.style.width = "100%";

      return;

    }

    const remaining = next.min - qty;

    els.reward.innerHTML =
      `Buy <strong>${remaining}</strong> more piece${remaining > 1 ? "s" : ""} to unlock <strong>${next.discount}% OFF</strong>`;

    let start = 1;

    if (activeTier) start = activeTier.min;

    let percent =
      ((qty - start) / (next.min - start)) * 100;

    percent = Math.max(0, Math.min(100, percent));

    els.progress.style.width = percent + "%";

  }

  function update() {

    const qty = getQty();

    const basePrice = getBasePrice();

    const tier = currentTier(qty);

    const discount = tier ? tier.discount : 0;

    const yourPrice =
      basePrice * (1 - discount / 100);

    const total =
      qty * yourPrice;

    const savings =
      qty * (basePrice - yourPrice);

    els.basePrice.textContent = money(basePrice);

    els.yourPrice.textContent = money(yourPrice);

    els.total.textContent = money(total);

    els.savings.textContent = money(savings);

    els.discount.textContent =
      discount ? discount + "% OFF" : "No Discount";

    refreshTable(basePrice, tier);

    refreshReward(qty, tier);

  }

  function updateVariant() {

    const variantField =
      document.querySelector('input[name="id"]') ||
      document.querySelector('select[name="id"]');

    if (!variantField || !window.productVariants) return;

    const id = String(variantField.value);

    const variant =
      window.productVariants.find(v => String(v.id) === id);

    if (!variant) return;

    wrapper.dataset.price = variant.price / 100;

    update();

  }

  update();

  document.body.addEventListener("input", e => {

    if (
      e.target.matches('input[name="quantity"]') ||
      e.target.matches(".quantity__input")
    ) {

      update();

    }

  });

  document.body.addEventListener("change", () => {

    setTimeout(updateVariant, 150);

  });

});